export const colorToRGBA = (color: string, alpha?: number) => {
    let r: number | string;
    let g: number | string;
    let b: number | string;
    if (color.startsWith('#')) {
        r = parseInt(color.slice(1, 3), 16);
        g = parseInt(color.slice(3, 5), 16);
        b = parseInt(color.slice(5, 7), 16);
    } else {
        [r, g, b] = color.split(',').map(value => value.replace(/\D+/g, ''));
    }

    if (alpha !== undefined) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
        return `rgba(${r}, ${g}, ${b})`;
    }
};
